<template>
    <div class="m-2">

        <div class="card m-2 shadow">

            <!--cabezera-->
            <div class="card-header">

                <div class="d-flex">
                    <div class="flex-fill">
                       <DenounceSearch></DenounceSearch>
                    </div>

                    <div class="float-end">
                        <DenouncePagination></DenouncePagination>
                    </div>

                </div>

            </div>

            <!--cuerpo-->
            <div class="card-body">
                <DenounceTable></DenounceTable>
            </div>
        </div>
    </div>
</template>
<script>
import DenouncePagination from '@/components/Denounce/DenounceList/Denounce-pagination.vue';
import DenounceSearch from '@/components/Denounce/DenounceList/Denounce-search.vue';
import DenounceTable from '@/components/Denounce/DenounceList/Denounce-table.vue'

export default {
    name: 'DenounceList',

    components:{
        DenouncePagination,
        DenounceSearch,
        DenounceTable
    }

}
</script>
<style></style>